import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CardV2 } from "../../../components/CardV2/CardV2";
import ListContainer from "../../../components/ListContainer/ListContainer";
import ListElement from "../../../components/ListElement/ListElement";
import ElementActions from "../../../components/ElementActions/ElementActions";
import PrimaryButton from "../../../components/PrimaryButton/PrimaryButton";
import TextArea from "../../../components/TextArea/TextArea";
import IconButton from "../../../components/IconButton/IconButton";
import { Icon } from "../../../components/Icon/Icon";
import deleteIcon from "../../../assets/images/bin.svg";
import { isValidText } from "../../../shared/validation";

type FormConditionItem = { id: string; text: string };

interface RequestFormSectionProps {
  contractTemplate: any;
  updateContractTemplate: (value: any) => void;
}

export default function RequestFormSection({ contractTemplate, updateContractTemplate }: RequestFormSectionProps) {
  const { t } = useTranslation();
  const currentConditions: string[] = contractTemplate?.formConditions || [];
  const [newItem, setNewItem] = useState('');

  const elements: FormConditionItem[] = currentConditions.map((text, i) => ({
    id: `form-condition-${i}`,
    text,
  }));

  const handleMovedItem = (reordered: FormConditionItem[]) => {
    updateContractTemplate({ formConditions: reordered.map((item) => item.text) });
  };

  const handleDeleteItem = (index: number) => {
    const updated = currentConditions.filter((_: string, i: number) => i !== index);
    updateContractTemplate({ formConditions: updated });
  };

  const handleAddItem = () => {
    if (newItem.trim()) {
      updateContractTemplate({ formConditions: [...currentConditions, newItem.trim()] });
      setNewItem('');
    }
  };

  return (
    <CardV2>
      <div className="p-4">
        <div className="text-xs text-muted-foreground mb-4">
          {String(t('commission_contract_template.form_conditions_hint') ?? 'These conditions will be shown to brides when they fill out the request form to sell their dresses.')}
        </div>
        <ListContainer
          elements={elements}
          enableDragAndDrop
          onMovedItem={handleMovedItem}
          toElementFn={(item: FormConditionItem, index: number) => (
            <ListElement>
              <ElementActions
                actions={
                  <IconButton onClick={() => handleDeleteItem(index)}>
                    <Icon url={deleteIcon} cssStyles="w-5" />
                  </IconButton>
                }
              >
                <div className="flex-1 min-w-0">{item.text}</div>
              </ElementActions>
            </ListElement>
          )}
        />
        <TextArea
          label={String(t('commission_contract_template.form_conditions.placeholder') ?? 'Add a condition for the request form...')}
          validationFn={(value) => !!value && isValidText(value, 5)}
          defaultValue={newItem}
          onChange={(e) => setNewItem(e.target.value)}
        />
        <div className="container flex flex-wrap space-x-5 mt-2">
          <PrimaryButton
            text={String(t('commission_contract_template.form_conditions.add_button') ?? 'Add condition')}
            fn={handleAddItem}
          />
        </div>
      </div>
    </CardV2>
  );
}
